export function insertWidgetsInGrid(grid, widgets, columnsCount = 2) {
    // Create a copy of the original grid to avoid modifying it directly
    let newGrid = [...grid];
  
    // Step 1: Create a list of widgets with their original indices
    const widgetsWithIndices = widgets.map((widget, index) => ({
      originalIndex: index, // Store the original index in the widgets array
      position: widget.position,
    }));
  
    // Step 2: Filter out duplicate widgets by position, keeping the first occurrence
    const uniqueWidgets = [];
    const seenPositions = new Set();
  
    // Sort by position to ensure consistent ordering
    widgetsWithIndices.sort((a, b) => a.position - b.position);
  
    // Keep only the first widget for each position
    widgetsWithIndices.forEach(widget => {
      if (!seenPositions.has(widget.position)) {
        seenPositions.add(widget.position);
        uniqueWidgets.push(widget);
      }
    });
  
    // Step 3: Insert the unique widgets into the grid using their original indices
    let offset = 0;
  
    uniqueWidgets.forEach(widget => {
      const { position, originalIndex } = widget;
  
      // Calculate the target row based on position and columnsCount
      let targetRow = Math.floor(position / columnsCount);
  
      // Adjust the target row by the number of widgets already inserted
      targetRow += offset;
  
      // Create the widget row using the original index
      const widgetRow = [`WIDGET_${originalIndex}`, `WIDGET_${originalIndex}`];
  
      // Insert the widget row at the target position
      if (targetRow <= newGrid.length) {
        newGrid.splice(targetRow, 0, widgetRow);
      } else {
        newGrid.push(widgetRow);
      }
  
      // Increment the offset since we’ve added a new row
      offset++;
    });
  
    return newGrid;
  }